<template>
  <div class="linglManager">
    <el-container>
      <el-header>
        <div style="width: 100%; background: #d5e7ed">
          <el-tabs
            v-model="activeName"
            type="card"
            @tab-click="handleTabClick"
            style="width: 100%"
          >
            <el-tab-pane label="全部" name="first"></el-tab-pane>
            <el-tab-pane label="待审核" name="second"></el-tab-pane>
            <el-tab-pane label="已通过" name="third"></el-tab-pane>
            <el-tab-pane label="已驳回" name="fourth"></el-tab-pane>
          </el-tabs>
        </div>
        <el-form ref="form" :model="Contractform" :inline="true">
          <el-row>
            <el-col :span="6">
              <el-form-item label="合同编号" label-width="120px">
                <el-input
                  v-model="Contractform.serialNumber"
                  placeholder="-请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="合同名称" label-width="120px">
                <el-input
                  v-model="Contractform.name"
                  placeholder="-请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="合同分类" label-width="120px">
                <el-select
                  v-model="Contractform.typeKey"
                  filterable
                  default-first-option
                >
                  <el-option
                    :label="item.value"
                    :value="item.label"
                    v-for="(item, index) in ContractClassList"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <div v-if="showAdvanceFilter">
              <el-col :span="6">
                <el-form-item label="状态" label-width="120px">
                  <el-select
                    v-model="Contractform.approveStatus"
                    placeholder="请选择"
                    default-first-option
                  >
                    <el-option label="草稿" value="0"></el-option>
                    <el-option label="已驳回" value="4"></el-option>
                    <el-option label="待审核" value="2"></el-option>
                    <el-option label="已通过" value="3"></el-option>
                    <el-option label="撤回" value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="合同金额" label-width="120px">
                  <el-input v-model="Contractform.amountStart"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <el-form-item label="——" label-width="30px">
                  <el-input v-model="Contractform.amountEnd"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="签订日期" label-width="120px">
                  <el-date-picker
                    v-model="Contractform.signDate"
                    type="daterange"
                    range-separator="至"
                    @blur="handleTimestamp"
                    value-format="yyyy-MM-dd"
                    start-placeholder="开始日期"
                    end-placeholder="截至日期"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="合同甲方" label-width="120px">
                  <el-input
                    v-model="Contractform.partyA"
                    placeholder="-请输入-"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="合同乙方" label-width="120px">
                  <el-input
                    v-model="Contractform.partyB"
                    placeholder="-请输入-"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="6">
                <el-form-item label="签订地点" label-width="120px">
                  <el-input
                    v-model="Contractform.signPlace"
                    placeholder="-请输入"
                  ></el-input>
                </el-form-item>
              </el-col> -->
              <el-col :span="6">
                <el-form-item label="是否临时" label-width="120px">
                  <el-select
                    v-model="Contractform.contractType"
                    placeholder="请选择"
                    default-first-option
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option label="否" value="ADDITIONAL"></el-option>
                    <el-option label="是" value="TEMPORARY"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="申请部门" label-width="120px">
                  <el-cascader
                    v-model="Contractform.applyDeptName"
                    :options="subDeptList"
                    :props="defaultProps"
                    @change="handleChange"
                    placeholder="请选择"
                    @active-item-change="handleChange"
                    change-on-select
                    :editable="false"
                  ></el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="申请人" label-width="120px">
                  <el-input
                    v-model="Contractform.applyUserName"
                    placeholder="-请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </div>
            <el-col :span="showAdvanceFilter ? 6 : 6">
              <div class="handlePanel">
                <el-button type="primary" icon @click="handleClick()"
                  >查询</el-button
                >
                <el-button type="info" icon @click="clearSearchConditions"
                  >重置</el-button
                >
                <el-button type="text" @click="moreScreen">{{
                  showAdvanceFilter ? "收起" : "高级筛选"
                }}</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
        <el-col :span="24" style="padding: 0 20px">
          <div class="operatePanel">
            <el-button
              type="primary"
              v-if="btnAuthorize.addBtn.btnEnable"
              icon="el-icon-plus"
              @click="createContract()"
              >新建</el-button
            >
            <el-button
              type="primary"
              v-if="btnAuthorize.modifyBtn.btnEnable"
              icon="el-icon-edit"
              @click="editContract()"
              >修改</el-button
            >
            <el-button
              type="primary"
              v-if="btnAuthorize.delBtn.btnEnable"
              icon="el-icon-delete"
              @click="DelectContract()"
              >删除</el-button
            >
            <!-- <el-button
              type="primary"
              v-if="btnAuthorize.approve.btnEnable"
              icon="el-icon-plus"
              @click="approveContract()"
              >审批</el-button
            > -->
            <el-button
              type="primary"
              v-if="btnAuthorize.callback.btnEnable"
              icon="el-icon-minus"
              @click="CallbackContract()"
              >撤回</el-button
            >
            <el-button
              type="primary"
              v-if="btnAuthorize.modifyBtn.btnEnable"
              icon="el-icon-edit"
              @click="addMoreContract()"
              >追加总包合同</el-button
            >
            <el-button
              title="导出当前列表查询出的数据，列表显示字段即为导出表格中数据字段。"
              type="primary"
              v-if="btnAuthorize.export.btnEnable"
              icon="el-icon-download"
              @click="exportCurrentList()"
              >导出</el-button
            >
            <el-button
              title="导出当前列表查询出的数据，列表显示字段即为导出表格中数据字段。"
              type="primary"
              v-if="btnAuthorize.export.btnEnable"
              icon="el-icon-download"
              @click="exportCurrentAllList()"
              >全部导出</el-button
            >
          </div>
        </el-col>
      </el-header>
      <el-main ref="main">
        <el-table
          ref="multipleTable"
          :data="tableData"
          border
          size="mini"
          style="width: 100%"
          height="100%"
          @selection-change="handleSelectionChange"
          @row-click="rowClicked"
          @cell-dblclick="ContractDetail"
        >
          <el-table-column type="selection" width="54"></el-table-column>
          <el-table-column
            v-for="(item, index) in tableColumnDatas"
            :key="index"
            :prop="item.class"
            :label="item.labelName"
            :sortable="item.sortEnable"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="item.isNumFilter">{{
                scope.row[scope.column.property] | numFilter
              }}</span>
              <span v-else-if="item.contractType">{{
                scope.row[scope.column.property] === "TEMPORARY" ? "是" : "否"
              }}</span>
              <span v-else>{{ scope.row[scope.column.property] }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer>
        <div style="display: flex; justify-content: space-between">
          <span
            style="
              color: #666666;
              font-size: 14px;
              line-height: 32px;
              margin-top: 16px;
            "
            >显示{{
              totalCount > 0
                ? (currentPage - 1) * pageSize +
                  1 +
                  "-" +
                  (currentPage * pageSize > totalCount
                    ? totalCount
                    : currentPage * pageSize)
                : "0"
            }}，共{{ totalCount }}条记录</span
          >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[20, 30, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          ></el-pagination>
        </div>
      </el-footer>
    </el-container>

    <!-- 导入总包合同 -->
    <upload-dialog
      :isShow="showUploadDialog"
      @close="closeDialogAction"
      :isImportContract="isImportContractDialog"
    />
  </div>
</template>

<script>
import UploadDialog from "./ContractDetail/UploadDialog"; //导入总包合同组件
import {
  getBasicDataListService, //获取总包合同编码接口
  getAllContractList, //获取总包合同列表接口
  exportExcelService2, //导出
  exportAllContractList, //导出总包合同接口
  exportContractList, //根据查询条件导出总包合同
  exportContractExcel, //下载总包合同Excel模板
  deleteOneAllContractSevice, //删除一条总包合同数据
} from "../../services/allContractServices";
import {
  getProjectGMListService, //获取项目经理列表
  getsubDeptService, //获取项目部二级项目级联列表
  getDeptListService, //根据组织获取项目部一级数据下拉列表
} from "../../services/sysSettingService";
import { recallApproveItemFun } from "@/page/approveComponents/approve";
export default {
  name: "AllContractMag",
  components: {
    UploadDialog,
  },
  props: {
    menuCode: {
      type: String,
    },
  },
  data() {
    return {
      assignDiaVisible: false,
      activeName: "first",
      orgId: 0, //存储组织id
      contractCodeList: [], //合同编码
      ContractnameList: [], //合同名称
      ContractClassList: [], //合同分类下拉框数据
      selectItems: [], //记录选中的总包合同行
      showUploadDialog: false, //导入总包合同对话框展示与否
      isImportContractDialog: true,
      category: "GENERAL_CONTRACT_SERIAL_NUMBER", //下拉列表类型
      currentUserId: "", //当前登录用户id
      subDeptList: [], //子部门列表
      //查询条件form
      Contractform: {
        id: "",
        serialNumber: "", //合同编号
        name: "", //合同名称
        project: "", //所属项目
        partyA: "", //合同甲方
        partyB: "", //合同乙方
        projectTime: "", //工期
        provisionalAmount: "", //暂定金金额
        signDate: "", //签订日期
        signDateStart: "", //签订时间起
        signDateEnd: "", //签订时间止
        signPlace: "", //签订地点
        amount: "", //合同金额
        amountStart: "", //
        amountEnd: "", //
        applyDeptName: "", //申请人部门ID
        applyUserId: "", //申请人ID
        applyUserName: "", //申请人姓名
        approveUserId: "", //当前审批人
        approveStatus: "", //单据状态
        typeKey: "", //合同分类
        updateTime: "", //更新时间
        contractType: "", //是否追加
        tabIndex: "0", //tab页分类
      },
      ProjectGMList: [], //审批对话框项目经理下拉列表
      tableColumnDatas: [
        { class: "serialNumber", labelName: "合同编号", sortEnable: false },
        { class: "name", labelName: "合同名称", sortEnable: false },
        { class: "partyA", labelName: "合同甲方", sortEnable: false },
        { class: "partyB", labelName: "合同乙方", sortEnable: false },
        {
          class: "amount",
          labelName: "合同金额",
          sortEnable: false,
          isNumFilter: true,
        },
        { class: "signDate", labelName: "签订日期", sortEnable: false },
        { class: "signPlace", labelName: "签订地点", sortEnable: false },
        { class: "applyUserName", labelName: "申请人", sortEnable: false },
        { class: "applyDeptName", labelName: "申请部门", sortEnable: false },
        { class: "approveStatusName", labelName: "状态", sortEnable: false },
        { class: "flowNo", labelName: "流水号", sortEnable: false },
        {
          class: "contractType",
          labelName: "是否临时",
          sortEnable: false,
          contractType: true,
        },
      ],
      showAdvanceFilter: false,
      currentPage: 1,
      pageSize: 20,
      totalCount: 0,
      tableData: [],
      compList: [],
      posts: [], //岗位数组
      showExportDialog: false,
      islastApproveUser: false, //是否为最后一位审批人
      btnAuthorize: {
        addBtn: { key: "create", btnEnable: false },
        modifyBtn: { key: "update", btnEnable: false },
        delBtn: { key: "delete", btnEnable: false },
        import: { key: "import", btnEnable: false }, //导入
        // approve: { key: "approve", btnEnable: false }, //审核
        callback: { key: "callback", btnEnable: false }, //审核
        export: { key: "export", btnEnable: false },
      },
      defaultProps: {
        label: "name",
        value: "name",
        lazy: true,
        lazyLoad(node, resolve) {
          const param = {};
          if (node.value) {
            param.deptId = node.data.id;
            getsubDeptService(param).then((res) => {
              if (res.code == 10000000) {
                const nodes = res.data;
                nodes.forEach((item) => {
                  item.leaf = item.isLeaf == 1;
                });
                resolve(nodes);
              } else {
                this.$message.error(res.msg);
              }
            });
          }
        },
      },
    };
  },
  mounted() {
    this.currentUserId = sessionStorage.getItem("currentUserId");
    this.orgId = sessionStorage.getItem("orgId");
  },
  methods: {
    handleTimestamp() {
      this.$forceUpdate();
    },
    onActive(menuCode) {
      // this.clearSearchConditions(); //重置查询条件
      this.Contractform.id = this.tabRouteParam?.id ?? "";
      this.activeName = "first";
      this.Contractform.tabIndex = "0";
      this.currentPage = 1;
      //合同分类
      this.category = "GENERALCONTRACTTYPE"; //合同分类
      this.getContractCode(this.category); //获取合同名称下拉框数据
      this.$getRoleBtns(menuCode, this.btnAuthorize);
      this.initList(); //获取下拉列表  gaa 20200806
      let pid = 0;
      this.getsubListData(pid);
    },
    //点击查询
    handleClick() {
      this.currentPage = 1;
      this.initList();
    },
    //审批关闭
    handleClose(done) {
      this.$confirm("确认关闭审批弹窗吗?", "提示", {
        confirmButtonText: "确认",
      })
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    //下载总包合同模板
    downTemplate() {
      exportContractExcel()
        .then((res) => {})
        .catch((error) => {});
    },
    //获取category下拉框数据
    getContractCode(category) {
      let param = {};
      param.category = category;
      getBasicDataListService(param)
        .then((res) => {
          if (res.code == 10000000) {
            if (category == "GENERAL_CONTRACT_SERIAL_NUMBER") {
              this.contractCodeList = res.data; //总包合同编码
            } else if (category == "GENERAL_CONTRACT_NAME") {
              this.ContractnameList = res.data; //合同名称
            } else {
              this.ContractClassList = res.data; //合同分类
            }
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {});
    },

    //获取总包合同列表
    initList() {
      let param = {
        // currentUserId: this.currentUserId, // sessionStorage.getItem("userCode"),
        // sort: "name",
        // order: "asc",
        tabIndex: this.Contractform.tabIndex,
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
      };
      for (let key in this.Contractform) {
        if (this.Contractform[key] !== "") {
          param[key] = this.Contractform[key];
        }
      }
      if (this.Contractform.signDate && this.Contractform.signDate.length > 1) {
        param.signDateStart = this.Contractform.signDate[0];
        param.signDateEnd = this.Contractform.signDate[1];
        delete param.signDate;
      }
      getAllContractList(param, true)
        .then((res) => {
          if (res.code == 10000000) {
            this.dealTableData(res);
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {
          this.$message.error("系统异常");
        });
    }, //
    dealTableData(res) {
      this.tableData = res.data;
      this.tableHeight = this.$refs.main.$el.offsetHeight - 10;
      this.totalCount = res.total;
    }, //

    onSearch() {
      this.currentPage = 1;
      this.initList();
    },
    //重置查询条件
    clearSearchConditions() {
      for (let key in this.Contractform) {
        if (key != "tabIndex") {
          this.Contractform[key] = "";
        }
      }
    }, //
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initList();
    }, //
    handleCurrentChange(page) {
      this.currentPage = page;
      this.initList();
    },
    //选择总包合同
    handleSelectionChange(val) {
      if (val) {
        this.selectItems = val;
      }
    }, //
    // 点击选中行
    rowClicked(row, event, column) {
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    //双击跳转总包合同详情
    ContractDetail(row, column, cell, event) {
      this.bus.$emit("tabClose", "mineReVisitList");
      this.$nextTick(() => {
        let param = {};
        param.id = row.id;
        param.routeId = "mineReVisitList";
        this.bus.$emit("navMenuChange", {
          routeId: "mineReVisitList",
          routeParam: param,
        });
      });
    },
    //tab页切换
    handleTabClick(tab, event) {
      this.currentPage = 1;
      switch (this.activeName) {
        case "first":
          this.Contractform.tabIndex = "0";
          break;
        case "second":
          this.Contractform.tabIndex = "1";
          break;
        case "third":
          this.Contractform.tabIndex = "2";
          break;
        case "fourth":
          this.Contractform.tabIndex = "3";
          break;
        default:
          this.Contractform.tabIndex = "0";
          break;
      }
      this.initList();
    },
    //根据查询条件导出全部总包合同
    exportCurrentAllList() {
      let param = {};
      for (let key in this.Contractform) {
        if (this.Contractform[key] != "") {
          param[key] = this.Contractform[key];
        }
      }
      if (this.Contractform.signDate && this.Contractform.signDate.length > 1) {
        param.signDateStart = this.Contractform.time[0];
        param.signDateEnd = this.Contractform.time[1];
        delete param.signDate;
      }
      exportContractList(param)
        .then((res) => {
          if (res.code == 10000000) {
            exportExcelService2(res.data).then((res1) => {
              this.$alert("导出成功", "提示", {
                confirmButtonText: "确定",
              });
            });
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch(() => {});
    },

    //导出总包合同列表
    exportCurrentList() {
      if (this.selectItems.length < 1) {
        this.$alert("请选择要导出的数据", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      let param = {};
      param.exportIds = new Array();
      // this.selectItems.forEach(item => {
      //   param.exportIds.push(item.id);
      // });
      // param.exportIds=exportIds;
      for (let i = 0; i < this.selectItems.length; i++) {
        param.exportIds[i] = this.selectItems[i].id;
      }
      exportAllContractList(param)
        .then((res) => {
          if (res.code == 10000000) {
            exportExcelService2(res.data).then((res1) => {
              this.$alert("导出成功", "提示", {
                confirmButtonText: "确定",
              });
            });
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch(() => {});
    },
    //导入总包合同
    importContract() {
      this.isImportContractDialog = false;
      this.showUploadDialog = true;
    },
    //跳转到创建新总包合同界面
    createContract() {
      let memberData = {};
      memberData.editFlag = false; //新增标志为0
      memberData.contractType = "add"; //新增标志为0

      // memberData.path = "order-list";
      this.bus.$emit("navMenuChange", {
        routeId: "find-classify",
        routeParam: memberData,
      });
    },
    //跳转到修改总包合同界面
    editContract() {
      if (this.selectItems.length != 1) {
        this.$alert("请选择一条数据", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      if (
        this.selectItems[0].approveStatus != 1 &&
        this.selectItems[0].approveStatus != 4 &&
        this.selectItems[0].approveStatus != 0
      ) {
        this.$alert("只有 撤回/驳回/已保存 状态的合同可以修改", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      let memberData = {};
      memberData.editFlag = true; //编辑标志为1
      memberData.id = this.selectItems[0].id; //选中行
      // memberData.path = "order-list";
      this.bus.$emit("navMenuChange", {
        routeId: "find-report",
        routeParam: memberData,
      });
    },
    //跳转追加总包合同界面
    addMoreContract() {
      if (this.selectItems.length != 1) {
        this.$alert("请选择一条数据", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      if (
        this.selectItems[0].contractType === "ADDITIONAL" ||
        this.selectItems[0].approveStatus !== 3
      ) {
        this.$alert("只有已通过的临时合同才能追加合同", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      let memberData = {};
      memberData.editFlag = false; //编辑标志为1
      memberData.contractType = "addMore"; //追加总包合同标志
      memberData.id = this.selectItems[0].id; //选中行
      memberData.serialNumber = this.selectItems[0].serialNumber; //选中行
      // memberData.path = "order-list";
      this.bus.$emit("navMenuChange", {
        routeId: "find-report",
        routeParam: memberData,
      });
    },

    //删除总包合同
    DelectContract() {
      if (this.selectItems.length != 1) {
        this.$alert("请选择一条数据", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }

      let param = {
        // currentUserId: 1 //sessionStorage.getItem("userCode"),
      };
      param.delIds = this.selectItems[0].id;
      this.$confirm("确认删除该条总包合同数据吗?", "提示", {
        confirmButtonText: "确认",
      }).then(() => {
        deleteOneAllContractSevice(param)
          .then((res) => {
            if (res.code == 10000000) {
              this.$alert("删除成功", "提示", {
                confirmButtonText: "确定",
              });
              this.handleClick();
            } else if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.$message.error("网络请求失败");
          });
      });
    },

    //撤回总包合同
    CallbackContract() {
      if (this.selectItems.length != 1) {
        this.$alert("请选择一条数据", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      let param = {
        itemId: this.selectItems[0].id,
        type: "GENERAL_CONTRACT",
      };
      this.$confirm("确认撤回该条总包合同数据吗?", "提示", {
        confirmButtonText: "确认",
      }).then(async () => {
        let res = await recallApproveItemFun(param);
        if (res && res.code == 10000000) {
          this.$message.success("撤回成功");
          this.handleClick();
        }
      });
    },

    //关闭导入总包合同对话框
    closeDialogAction() {
      this.showUploadDialog = false;
    },
    closeDialog() {
      this.showExportDialog = false;
    },
    moreScreen() {
      this.showAdvanceFilter = !this.showAdvanceFilter;
      if (this.showAdvanceFilter) {
        this.tableHeight = this.$refs.main.$el.offsetHeight - 144 - 10;
      } else {
        this.tableHeight = this.$refs.main.$el.offsetHeight + 144 - 10;
      }
    },
    //获取子部门下拉列表数据
    getsubListData(deptId) {
      let reqParam = {
        deptId: deptId,
      };
      getsubDeptService(reqParam).then(
        (res) => {
          if (res.code == 10000000) {
            // this.total = res.total;
            this.subDeptList = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$alert(err, "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },
    //部门失去焦点时获取数据
    handleChange(value) {
      let len = value.length;
      this.Contractform.applyDeptName = value[len - 1];
    },
  },
};
</script>

<style scoped >
/deep/.el-tabs__header {
  padding-right: 0 !important;
  background: #d5e7ed !important;
}
>>> .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background: #fff;
  color: #069dbc !important;
  border-bottom-color: #e4e7ed;
}
>>> .el-tabs__item:hover {
  color: #069dbc;
}
</style>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.el-container {
  padding-top: 0;
  .el-header {
    padding: 0;
    form {
      padding-right: 20px;
    }
  }
}
.linglManager {
  height: 100%;
  background-color: white;
}
/deep/.el-tabs__header {
  padding-right: 0 !important;
  background: #d5e7ed !important;
}
.el-select {
  width: 100%;
}
.hide {
  display: none;
}

/deep/.overTimeMark {
  // background-color: #e9f4fa;
  .el-tooltip {
    color: #333333;
  }
}

/deep/.el-form-item__content {
  width: 60%;
}
/deep/.el-form-item {
  width: 100%;
}
/deep/.el-date-editor {
  width: 100% !important;
}
</style>
